import { useEffect, useState } from 'react';
import { AnimatePresence, m } from 'framer-motion';
import { getCategoryMeta } from '@brainfart/shared';
import { fetchLaunchedTopics, markLaunchedSeen, type LaunchedTopic } from '../topicRequests';
import { track } from '../telemetry';

// Homepage: "✨ New: Formula 1 is live, you asked for it". Shown until you
// play it or dismiss it (the push covers players with notifications on).
export function LaunchedTopicBanner({ onPlay }: { onPlay: (category: string) => void }) {
  const [topic, setTopic] = useState<LaunchedTopic | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchLaunchedTopics().then(list => { if (!cancelled) setTopic(list[0] ?? null); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const meta = topic ? getCategoryMeta(topic.category) : null;
  const dismiss = () => {
    setTopic(null);
    markLaunchedSeen().catch(() => {});
  };

  return (
    <AnimatePresence>
      {topic && meta && (
        <m.div
          key={topic.id}
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, height: 0 }}
          style={{
            display: 'flex', alignItems: 'center', gap: '0.9rem', padding: '1rem 1.1rem', borderRadius: '18px',
            background: `linear-gradient(135deg, ${meta.color}40, #1B1830)`, border: `1px solid ${meta.color}88`,
          }}
        >
          <span style={{ fontSize: '2.2rem', lineHeight: 1 }}>{meta.icon}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ fontWeight: 800, color: '#fff' }}>✨ New: {meta.title} is live!</p>
            <p style={{ color: '#bbb', fontSize: '0.85rem' }}>You asked for {topic.topic}. Be first on the board.</p>
          </div>
          <button
            className="btn btn-primary"
            onClick={() => {
              track({ type: 'topic_launch_opened', payload: { category: topic.category } });
              markLaunchedSeen().catch(() => {});
              onPlay(topic.category);
            }}
            style={{ padding: '0.55rem 0.9rem', fontSize: '0.9rem', flexShrink: 0, width: 'auto' }}
          >
            Play
          </button>
          <button onClick={dismiss} aria-label="Dismiss" style={{ background: 'none', border: 'none', color: '#888', fontSize: '1.1rem', cursor: 'pointer', padding: '0.25rem', flexShrink: 0 }}>
            ✕
          </button>
        </m.div>
      )}
    </AnimatePresence>
  );
}
